import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

export const getAllSessions = async (status: number | null) => {
    try {
        const response = await Axios.get(`/chat_logs/store/session?status=${status}`);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useGetAllSessions = ({ enabled, status }: { enabled: boolean; status: number | null }) => {
    const sessions = useQuery({
        queryKey: ["get_all_sessions", status],
        queryFn: () => getAllSessions(status),
        enabled,
    });

    return sessions;
};
